import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, isRef as _isRef, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createBlock as _createBlock, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "sc-form d-flex align-items-center" }
const _hoisted_3 = ["name", "id"]

import {
  toRef,
  ref,
  computed,
  onMounted,
  watch,
} from "vue";
import { ErrorMessage, useField } from "vee-validate";
import { EmployerTypeIds, EmployerRecord } from "@/models/employer";
import { validateStringInput } from "@/use/validation";

interface Props {
  initialValue?: string | null;
  employer: EmployerRecord;
  name: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AddEmployerForm',
  props: {
    initialValue: {},
    employer: {},
    name: {}
  },
  emits: ["deleteEmployer", "update-modelValue"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const emit = __emit;

const props = __props;

// Template Refs
const fieldRef = ref<HTMLInputElement | null>(null);

const name = toRef(props, "name");

const isCurrentEmployer = computed<boolean>(
  () => props?.employer?.employerTypeId === EmployerTypeIds.Current,
);

function handleInput() {
  emit("update-modelValue", value.value);
}

const { handleChange, value, errors, setValue } = useField(name.value || "employer_0", value => {
  if (isCurrentEmployer.value && !validateStringInput(value)) {
    return "Current Employer is required";
  }
  return true;
});

function handleIconClick() {
  console.log("handleClick");
  if (isCurrentEmployer.value && fieldRef.value) {
    fieldRef.value.disabled = false;
  } else {
    deleteEmployer();
  }
}

function deleteEmployer() {
  emit("deleteEmployer", props.employer.id);
}

onMounted(() => {
  if (props.initialValue) {
    setValue(props.initialValue);

    if (isCurrentEmployer.value && fieldRef.value) {
      fieldRef.value.disabled = true;
    }
  }
});

watch(value, (newValue, oldValue) => {
  // sync it with vee-validate, this will trigger validation
  handleChange(newValue);
});

__expose({
  fieldRef,
  value,
	setValue,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _mergeProps({ class: "employer" }, _ctx.$attrs), [
    (isCurrentEmployer.value)
      ? (_openBlock(), _createElementBlock("label", _hoisted_1, "Current Employer"))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("input", {
        ref_key: "fieldRef",
        ref: fieldRef,
        name: name.value,
        id: name.value,
        type: "text",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(value) ? (value).value = $event : null)),
        onChange: handleInput
      }, null, 40, _hoisted_3), [
        [_vModelText, _unref(value)]
      ]),
      _createElementVNode("span", {
        class: _normalizeClass(isCurrentEmployer.value ? 'icon-pencil' : 'icon-x'),
        onClick: handleIconClick
      }, null, 2)
    ]),
    (_unref(errors))
      ? (_openBlock(), _createBlock(_unref(ErrorMessage), {
          key: 1,
          class: "error",
          name: name.value
        }, null, 8, ["name"]))
      : _createCommentVNode("", true)
  ], 16))
}
}

})